<template>
  <ContentWrapper :title="labels.LBL_TEAM_MEMBERS" back>
    <template slot="actions">
      <el-button
        size="small"
        type="success"
        @click="submitForm('executiveForm')"
      >
        <i class="el-icon-check mr-1"></i>
        {{ labels.LBL_SAVE }}
      </el-button>
    </template>

    <el-form
      v-loading="loading"
      ref="executiveForm"
      :model="executive"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="labels.LBL_PHOTO">
            <UploadImage v-model="executive.photo" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="salutation" :label="labels.LBL_SALUTATIONS">
            <el-select
              v-model="executive.salutation"
              placeholder="Select Salutation"
            >
              <el-option
                v-for="item in salutations"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="first_name" :label="labels.LBL_FIRST_NAME">
            <el-input v-model="executive.first_name"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="last_name" :label="labels.LBL_LAST_NAME">
            <el-input v-model="executive.last_name"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="email" :label="labels.LBL_EMAIL">
            <el-input v-model="executive.email" type="email"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="phone" :label="labels.LBL_CONTACT_NO">
            <el-input v-model="executive.phone"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="address" :label="labels.LBL_ADDRESS">
            <el-input v-model="executive.address"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="highest_education"
            :label="labels.LBL_HIGHEST_EDU"
          >
            <el-input v-model="executive.highest_education"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item prop="designation_id" :label="labels.LBL_DESIGNATION">
            <el-select
              v-model="executive.designation_id"
              :placeholder="labels.PH_SELECT_DESIGNATION"
            >
              <el-option
                v-for="item in designationList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="`${labels.LBL_FB} ${labels.LBL_URL}`">
            <el-input v-model="executive.facebook_link"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="`${labels.LBL_TWI} ${labels.LBL_URL}`">
            <el-input v-model="executive.twitter_link"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="`${labels.LBL_LNKIN} ${labels.LBL_URL}`">
            <el-input v-model="executive.linkedin_link"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item prop="voice" :label="labels.LBL_ABOUT">
            <el-input
              type="textarea"
              :rows="4"
              v-model="executive.voice"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </ContentWrapper>
</template>

<script>
  import { mapGetters, mapState } from "vuex";
  import { labels, rules } from "@/common";
  import Executive from "@/models/executive";
  import ContentWrapper from "@/components/layouts/AdminContentWrapper";
  import UploadImage from "@/components/UploadImage";

  export default {
    name: "AddMember",

    components: {
      ContentWrapper,
      UploadImage,
    },

    data() {
      return {
        labels,

        executive: new Executive(),

        rules,
      };
    },

    computed: {
      ...mapState({
        loading: (state) => state.isBusy,
        designationList: (state) => state.executive.designations,
      }),

      ...mapGetters({
        salutations: "executive/salutationDDL",
      }),

      isPresident() {
        return this.executive.designation_id === 1;
      },
    },

    mounted() {
      this.loadDesinations();
      this.loadSalutations();
    },

    methods: {
      loadDesinations() {
        this.$store.dispatch("executive/getDesignations");
      },

      loadSalutations() {
        this.$store.dispatch("executive/getSalutations");
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$store.dispatch("executive/createExecutive", this.executive);
          }
        });
      },
    },
  };
</script>

<style></style>
